let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("koyH0")).then(() => parcelRequire('jgXd4'));